import { Suspense } from "react";
import { LoadingState } from "app/components/ui/feedback";

/** Wraps a React.lazy component in Suspense with the standard loading state. */
const Loadable = (Component) => (props) => (
  <Suspense fallback={<LoadingState fullPage label="Loading…" />}>
    <Component {...props} />
  </Suspense>
);

export default Loadable;
